import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { OnboardingPage } from '../../../ui';
import Browsers from './CompleteProfile/Browsers';
import Devices from './CompleteProfile/Devices';
import Personal from './CompleteProfile/Personal';
import Phone from './CompleteProfile/Phone';

const mapStateToProps = (state) => {
  return {
    device: state.resolution.device,
  };
};

// URL step → stepper label, in registration order
const steps = [
  { id: 'personal', label: 'Personal' },
  { id: 'phone', label: 'Phone' },
  { id: 'devices', label: 'Devices' },
  { id: 'browsers', label: 'Browsers' },
];

class CompleteProfile extends Component<any> {
  render() {
    const step = this.props.match.params.step;

    const isMobile = this.props.device === 'mobile' || this.props.device === 'mobile-tablet';

    return (
      <OnboardingPage
        steps={steps.map((el) => el.label)}
        activeStep={Math.max(0, steps.findIndex((el) => el.id === step))}
        isMobile={isMobile}
      >
        {step === 'personal' && <Personal />}
        {step === 'phone' && <Phone />}
        {step === 'devices' && <Devices />}
        {step === 'browsers' && <Browsers />}
      </OnboardingPage>
    );
  }
}

export default withRouter(connect(mapStateToProps, null)(CompleteProfile));
